import { render, staticRenderFns } from "./MassiveTreatmentAssignation.vue?vue&type=template&id=02820040&lang=pug"
import script from "./MassiveTreatmentAssignation.vue?vue&type=script&lang=js"
export * from "./MassiveTreatmentAssignation.vue?vue&type=script&lang=js"
import style0 from "./MassiveTreatmentAssignation.vue?vue&type=style&index=0&id=02820040&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports